import axios from "axios";
import { backend_url } from "../../constants";
import { AXIOS_CONFIG } from "../api";
import { Endpoints } from "./endpoints";

const API_URL = `${backend_url}/${Endpoints.members}`;

/**
 * Fetches the members from the management API.
 *
 * @param {object} [params] - Optional parameters to include in the request.
 * @returns {Promise<{businessStaff: any, counts: any, message: string}>}
 * An object containing businessStaff, counts, and message from the API response.
 * @throws Will throw an error if the request fails.
 */

export const getMembers = async (params?: object) => {
  try {
    const response = await axios.get(API_URL, {
      params,
      ...AXIOS_CONFIG,
    });
    return {
      businessStaff: response.data.content.businessStaff,
      counts: response.data.content.counts,
      message: response.data.content.message,
    };
  } catch (error) {
    console.error("Error fetching members:", error);
    throw error;
  }
};
/**
 * DELETE: api/management/members
 * Deletes all pending members, for a given business.
 * @param data {Object} Required data for the request, including email.
 * @returns {Promise<Object>} The response from the API.
 */

export const deletePendingMembers = async (data: object) => {
  try {
    const response = await axios.delete(API_URL, {
      data,
      ...AXIOS_CONFIG,
    });
    return response.data.content;
  } catch (error) {
    console.error("Error deleting members:", error);
    throw error;
  }
};
